import React from 'react';
import { useIntl } from 'react-intl';
import styled, { keyframes } from 'styled-components';

import { Box, LoadingDots, Text, Theme } from 'baukasten';

import messages from './messages';

// short turns stay calm; the counter only reassures once a wait feels long
const ELAPSED_VISIBLE_AFTER_S = 8;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(${Theme.getBaseUnit(1)});
  }
  to {
    opacity: 1;
    transform: none;
  }
`;

// remounts on every new label, which replays the fade
const FadeInText = styled(Text)`
  animation: ${fadeIn} 240ms ease-out;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

type Props = { label: string; elapsed: number };

export const ProgressHeadline = ({ label, elapsed }: Props) => {
  const { formatMessage } = useIntl();
  const showElapsed = elapsed >= ELAPSED_VISIBLE_AFTER_S;

  return (
    <>
      {/* the live region stays mounted while the keyed text swaps, so screen readers hear each line */}
      <Box as="span" aria-live="polite">
        <FadeInText key={label} fontSize={14} color="grey-dark">
          {label}
        </FadeInText>
      </Box>
      {showElapsed && (
        <Text fontSize={14} color="grey-dark">
          {formatMessage(messages.elapsedSeconds, { seconds: elapsed })}
        </Text>
      )}
      <LoadingDots />
    </>
  );
};
